<template>
  <tooltip :text="value.description" :disabled="!value.description" placement="top">
    <v-chip
      :color="value.color"
      :x-small="'x-small' === size"
      :small="'small' === size"
      :large="'large' === size"
      :x-large="'x-large' === size"
      dark
    >
      <v-icon
        v-if="value.icon"
        :x-small="'x-small' === size"
        :small="'small' === size"
        :large="'x-large' === size"
        left
      >
        {{ value.icon }}
      </v-icon>
      {{ value.value }}
    </v-chip>
  </tooltip>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { ITag } from "@/models/tag.entity";
import Tooltip from "../utility/tooltip.vue";

@Component({ components: { Tooltip } })
export default class TagChip extends Vue {
  @Prop({ required: true })
  value!: ITag;

  @Prop({ default: "medium" })
  size?: "x-small" | "small" | "medium" | "large" | "x-large";
}
</script>
